module.exports = __webpack_public_path__ + "img/gedenq_bg.e8cbd9f4.png";